import React, { Component } from 'react'
import NumberFormat from 'react-number-format'

// Components
import Loader from '../../../utils/Loader'
import ImageUploaderSimple from '../../../utils/ImageUploaderSimple'
import ImageUploader from '../../../utils/ImageUploader'

import ErrorWrap from '../../../utils/error-success/ErrorWrap'
import DynamicInputs from '../../../utils/DynamicInputs'
import PhoneFieldArray from '../../../utils/PhoneFieldArray'

// CSS
import '../../../../css/forms/dropzone-simple.css'

class BasicInfoFieldset extends Component {
	constructor(props) {
		super(props)

		this.dataProps = [
			'title',
			'former_title',

			'email',
			'website',
			'languages',
			'phone_numbers',
			'operating_expenditure',
		]
		this.miscProps = ['errors', 'languages', 'languagesError', 'languagesLoading']
	}

	shouldComponentUpdate(nextProps) {
		// Check local props to see if any have changed
		const dataPropResults = this.dataProps.some(prop => {
			return this.props.data[prop] !== nextProps.data[prop]
		})
		const miscPropResults = this.miscProps.some(prop => {
			return this.props[prop] !== nextProps[prop]
		})

		// If any local props changed, we will rerender
		return dataPropResults || miscPropResults
	}

	render() {
		const { data, languagesError, languagesLoading, languages, errors, inProcess } = this.props

		return (
			<div className='fieldset'>
				<div className='title-label'>Organization Info</div>
				{!!errors.new_pic && <ErrorWrap animate={1}>{errors.new_pic}</ErrorWrap>}
				<div className='fieldset-indent'>
					<div className='form-field '>
						<label>
							Logo:{' '}
							<span style={{ fontSize: '0.9em', color: '#777' }}>
								(JPG or PNG, recommended size e.g. 400x400px)
							</span>
						</label>

						<ImageUploaderSimple
							placeholder='Drag or select logo (JPG/PNG only)'
							loading={inProcess}
							initialImages={data.logo ? [data.logo] : []}
							required={false}
							type={'logo'}
							uploadAssetType={'reviewer'}
							handleExistingImageRemoval={this.props.clearPic}
							addPromise={promise => this.props.addImagePromise(promise)}
							clear={this.props.clearImageUploader}
						/>
					</div>

					<div className='floated-field-container'>
						<div className='form-field half-field'>
							<label>Title:</label>

							{!!errors.title && <ErrorWrap animate={1}>{errors.title}</ErrorWrap>}
							<input
								type='text'
								id='title'
								value={data.title}
								maxLength='255'
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>
						<div className='form-field half-field'>
							<label>Former Title:</label>

							{!!errors.former_title && <ErrorWrap animate={1}>{errors.former_title}</ErrorWrap>}
							<input
								type='text'
								id='former_title'
								value={data.former_title}
								maxLength='255'
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>
					</div>

					<div className='floated-field-container'>
						<div className='form-field half-field'>
							<label>Email:</label>

							{!!errors.email && <ErrorWrap animate={1}>{errors.email}</ErrorWrap>}
							<input
								type='email'
								id='email'
								value={data.email}
								maxLength='255'
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>

						<div className='form-field half-field'>
							<label>Website:</label>

							{!!errors.website && <ErrorWrap animate={1}>{errors.website}</ErrorWrap>}
							<input
								type='url'
								id='website'
								value={data.website}
								maxLength='255'
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>
					</div>

					<div className='form-field half-field'>
						<label>Phone Numbers:</label>

						{!!errors.phone_numbers && <ErrorWrap animate={1}>{errors.phone_numbers}</ErrorWrap>}
						<DynamicInputs
							index='phone_numbers'
							addInputToCollection={this.props.addPhoneInputToCollection}
							hasItems={data.phone_numbers.length}
						>
							{data.phone_numbers.map((phoneObj, i) => (
								<div key={i} className='dynamic-input'>
									<PhoneFieldArray
										dataName='phone_numbers'
										valueObj={phoneObj}
										inProcess={inProcess}
										index={i}
										handleKeyPress={this.props.handleKeyPress}
										handleInputChangeArray={this.props.handleInputChangeArray}
									/>
									{!!i && (
										<span
											className='icon-cross'
											onClick={() => this.props.deleteInputFromCollection('phone_numbers', i)}
										/>
									)}
								</div>
							))}
						</DynamicInputs>

						<div className='form-field half-field'>
							<label htmlFor='operating_expenditure'>Operating Expenditure:</label>
							{!!errors.operating_expenditure && (
								<ErrorWrap animate={1}>{errors.operating_expenditure}</ErrorWrap>
							)}
							{/* <input
								type="text"
								id="operating_expenditure"
								value={data.operating_expenditure}
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/> */}
							<NumberFormat
								placeholder='0'
								decimalScale={2}
								allowNegative={false}
								thousandSeparator={true}
								prefix={'$'}
								value={!!data ? data.operating_expenditure : null}
								// value="hello world"

								type='text'
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
								onValueChange={values =>
									this.props.updateSelectedValue(values.value, 'operating_expenditure')
								}
								disabled={inProcess}
							/>
						</div>
					</div>

					<div className='form-field checkbox'>
						<label className='pb1'>Languages:</label>

						{languagesError ? (
							<ErrorWrap>{languagesError}</ErrorWrap>
						) : languagesLoading ? (
							<Loader />
						) : (
							<div className='floated-field-container'>
								{!!errors.languages && <ErrorWrap animate={1}>{errors.languages}</ErrorWrap>}

								{!languages.length ? (
									<ErrorWrap>There are no language options available at the moment.</ErrorWrap>
								) : (
									<React.Fragment>
										{Object.keys(languages).map(key => {
											const { id } = languages[key]

											// Don't show "other"
											if (id === 'o') return null

											// See if this sector is checked off
											const selectedObject = data.languages.find(language => {
												return language.id === id
											})

											return (
												<div
													key={id}
													className={`custom-label checkbox-label${
														inProcess ? ' disabled-label' : ''
													}`}
												>
													<input
														type='checkbox'
														id={`languages_${key}`}
														value={id}
														checked={!!selectedObject}
														disabled={inProcess}
														onChange={e =>
															this.props.handleCheckboxClickArray(languages[key], 'languages')
														}
													/>
													<label htmlFor={`languages_${key}`}>{languages[key].title}</label>
												</div>
											)
										})}
									</React.Fragment>
								)}
							</div>
						)}
					</div>
				</div>
			</div>
		)
	}
}

export default BasicInfoFieldset



// WEBPACK FOOTER //
// ./src/components/admin/organizations/form-components/BasicInfoFieldset.js